import React, { useContext } from 'react';
import { DeviationViewMode } from '@wix/da-react-context/pkg/publicSession';

export const DeviationViewContext = React.createContext<DeviationViewMode>(
  DeviationViewMode.Normal
);
DeviationViewContext.displayName = 'DeviationViewContext';

export interface WithViewContextProps {
  viewMode: DeviationViewMode;
  isTheater: boolean;
  isFullscreen: boolean;
}

// hook for convenience...
export function useDeviationViewContext() {
  const viewMode = useContext(DeviationViewContext);
  const contextProps: WithViewContextProps = {
    viewMode,
    isTheater: viewMode === DeviationViewMode.Theater,
    isFullscreen: viewMode === DeviationViewMode.Fullscreen,
  };
  return contextProps;
}
